enum AppAttributeGroups {
  ImOperator = "ImOperator",
  ImSupervisor = "ImSupervisor",
  ImViewer = "ImViewer",
}
export default AppAttributeGroups;
